import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BotonTipo } from '../../../../components/boton/boton';
import { MatDialog } from '@angular/material';
import { EditarAccesorioDialog } from './editar-accesorio-dialog/editar-accesorio-dialog.component';

@Component({
  selector: 'app-editar-accesorio',
  templateUrl: './editar-accesorio.component.html',
  styleUrls: ['./editar-accesorio.component.scss']
})
export class EditarAccesorioComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() IdAccesorio?: number | string;
  @Input() disabled: boolean = false;
  @Input() tooltipDir: string = 'below';
  @Output() onCerrado = new EventEmitter();

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
    if (!this.IdAccesorio) {
      throw "La variable Input 'IdAccesorio' es requerida";
    }
  }

  openDialog(): void {
    let dialogEditar = this.dialog.open(EditarAccesorioDialog, {
      disableClose: true,
      data: {
        IdAccesorio: this.IdAccesorio
      }
    });

    dialogEditar.afterClosed().subscribe(resultado => {
      this.onCerrado.emit();
    });
  }
}
